import { gql } from '@apollo/client';

const COMPONENT_LIST_SETS = gql`
    query ComponentListSets {
        componentListSets {
            edges {
                node {
                    componentListSetId
                    type
                    name
                    description
                    isPublished
                    createdAt
                    updatedAt  
                    componentLists 
                    segmentIds
                    productIds
                    brandIds
                    categoryIds
                    companyRelationshipIds
                    employeeLocaleIds
                    learningProfileIds
                    localeIds
                    resourceIds
                    tagIds
                }
            }
        }
    }
`;

export default COMPONENT_LIST_SETS;
